"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledCard = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    overflow: visible;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    width: 100%;\n    max-width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCard = (0, _styledComponents["default"])(_Card["default"])(_templateObject(), _colors["default"].lychee[400]);
exports.StyledCard = StyledCard;
var _default = {
  StyledCard: StyledCard
};
exports["default"] = _default;